import { TransformState } from '../../../state/types';
import hashSource from '../../../utils/calculateHash';
import type { DataFormat } from '@generaltranslation/format/types';

/**
 * Track gt() function invocations
 * - Adds the translation content to the string collector
 */
export function registerUseGTCallback({
  identifier,
  state,
  content,
  context,
  id,
  maxChars,
  requiresReview,
  hash,
  format,
}: {
  identifier: number;
  state: TransformState;
  content: string;
  context?: string;
  id?: string;
  maxChars?: number;
  requiresReview?: boolean;
  hash?: string;
  format?: string;
}): void {
  // Calculate hash for the call expression (skip when the call site already carries one)
  hash ??= hashSource({
    source: content,
    context,
    maxChars,
    requiresReview,
    dataFormat: (format || 'ICU') as DataFormat,
  });

  // Add the translation content to the string collector (under identifier mapping to useGT call)
  state.stringCollector.pushTranslationContent(identifier, {
    message: content,
    hash,
    id,
    context,
    maxChars,
    requiresReview,
    format,
  });

  // Increment counter so we can revisit this same invocation on second pass
  const counterId = state.stringCollector.incrementCounter();

  // Register the hash under this counter
  state.stringCollector.setTranslationHash(counterId, {
    hash,
  });
}
